// extracted by mini-css-extract-plugin
module.exports = {"highlight":"AlertHighlighter_highlight__1Cq1-"};